// extracted by mini-css-extract-plugin
module.exports = {"tenantLabel":"TenantLabel_tenantLabel__2XSfX","disabled":"TenantLabel_disabled__3C1y_","tenantFlag":"TenantLabel_tenantFlag__1DR3m"};